import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import { useState, useEffect } from 'react';
import useGoogleAPI from './useGoogleAPI';
var DEFAULT_STATE = {
  loading: true,
  error: null,
  address: null,
  coordinates: null
};
/**
 * Try to detect gps coordinates for a human redeable address
 * @param {string} address
 * @param {string} apiKey
 * @returns {import('./types').CoordinatesState}
 */

var useCoordinates = function useCoordinates(apiKey, address) {
  var _useState = useState(DEFAULT_STATE),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var googleApi = useGoogleAPI(apiKey);

  var setCoordinatesState = function setCoordinatesState(loading, error, address, coordinates) {
    setState({
      loading: loading,
      error: error,
      address: address,
      coordinates: coordinates
    });
  };

  useEffect(function () {
    if (googleApi.loading) return;
    if (googleApi.error) return setCoordinatesState(false, googleApi.error, null, null);

    if (!address) {
      navigator.geolocation.getCurrentPosition(function (position) {
        setCoordinatesState(false, null, address, {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        });
      }, function (positionError) {
        setCoordinatesState(false, positionError.message, null, address);
      });
    } else {
      if (address === state.address) return; // same address

      /**@type {google.maps.GeocoderRequest} */

      var geocoderRequest = {
        address: address
      };
      var geocoder = new googleApi.google.maps.Geocoder();
      geocoder.geocode(geocoderRequest, function (results, status) {
        if (status === googleApi.google.maps.GeocoderStatus.OK) {
          setCoordinatesState(false, null, address, {
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng()
          });
        } else if (status === googleApi.google.maps.GeocoderStatus.ZERO_RESULTS) {
          setCoordinatesState(false, "Address not found and cannot be displayed", null, null);
        } else {
          setCoordinatesState(false, "An error has occured: " + status, null, null);
        }
      });
    }
  }, [googleApi, address]);
  return state;
};

export default useCoordinates;